import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {EndoMultiToothExamDataModel} from '../../../../../../models/forms/custom/mti/endo-multi-tooth-exam-data.model';
import {ToothConfigurationModel} from '../../../../../../models/teeth/tooth-configuration.model';
import {ToothService} from '../../../../../../services/tooth.service';

@Component({
  selector: 'app-mti-teeth-dialog',
  templateUrl: './mti-teeth-dialog.component.html',
  styleUrls: ['./mti-teeth-dialog.component.scss']
})
export class MtiTeethDialogComponent implements OnInit {
  exam: EndoMultiToothExamDataModel;
  cfgTeeth: ToothConfigurationModel[];

  constructor(private diagRef: MatDialogRef<MtiTeethDialogComponent>,
              private toothService: ToothService,
              @Inject(MAT_DIALOG_DATA) private data: any) {
    this.exam = data.exam;
    if (data.cfgTeeth) {
      this.cfgTeeth = data.cfgTeeth;
    } else {
      this.toothService.getAllTeeth(ToothService.enumUnitedStatesToothGrouping).subscribe((res) => {
        this.cfgTeeth = res;
      });
    }
  }

  ngOnInit(): void {
  }

  onCancelClick() {
    this.diagRef.close();
  }

  onOkClick() {
    this.diagRef.close();
  }

  getTitle() {
    const dataTooth = this.exam.dataEndoMutiToothExamTeethinExams[0].dataEndoMutiToothExamTooth.ToothId;
    const cfgTooth = this.cfgTeeth.find(p => p.ToothId === dataTooth);
    if (cfgTooth) {
      return cfgTooth.cfgToothDescriptions[0].Notation;
    } else {
      return '';
    }
  }
}
